import { AvailableLanguages, DEFAULT_LANGUAGE } from '@lib.core/locale/available-languages';

export class Context {
  /*
  * Includes configurations to control the behaviour of a selected group of components, services, etc.
  * These configurations include language, etc.
  * Application wide context is instantiated in the app component and stored in the store service.
  * Standalone pages (aka screens) which are registered in the router read application wide context from store.
  * */
  readonly id: string = `${Date.now()}-${Math.random()}`;
  lang = 'en';
  /** The language of the app's own text, its i18n keys, where it differs from `lang`, which data and formatting use. */
  i18nLang?: string;

  constructor(public nameId: string) {
  }
}

/** The language to read the app's i18n keys in: the context's own i18n language, else its language. */
export function i18nLanguageOf(ctx: Context | undefined): AvailableLanguages {
  return (ctx?.i18nLang ?? ctx?.lang ?? DEFAULT_LANGUAGE) as AvailableLanguages;
}
